<template>
  <div class="m-0 checkboxWrapper">
    <ValidationProvider :rules="validation" v-slot="{ errors }" :name="validationName">
      <div class="wrapper" :style="styles">
        <label class="container" :for="`checkbox_${fieldId}`">
          <span v-html="$t(label)"></span>
          <input
            v-model="localChecked"
            :name="validationName"
            :checked="checked"
            type="checkbox"
            :id="`checkbox_${fieldId}`"
            required
          />
          <span class="checkmark"></span>
          <span v-if="popup.status" class="popup" v-html="$t(popup.text)" @click.prevent="openPopup"></span>
        </label>
        <div
          role="button"
          aria-expanded="false"
          :aria-controls="fieldId"
        >
          <img
            v-if="expandable"
            class="down-arrow"
            src="../../assets/icons/form/down-arrow.svg"
            alt
          />
        </div>
      </div>
      <div v-if="expandable" class="collapse" :id="'expandable_' + fieldId">
        <div class="card card-body card-body-dop" v-html="$t(expandableText)"></div>
      </div>
      <div class="validation-error" style="margin-left: 5px;" v-if="errors.length">
        <img class="error_min" src="../../assets/icons/form/error.svg" alt="error">
        {{ errors[0] }}
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
import store from "../../store";

export default {
  name: "checkbox",
  data () {
    return {
      localChecked: this.checked
    };
  },
  props: {
    label: {
      type: String,
      default: "Empty Link Text"
    },
    name: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    expandable: {
      required: false,
      type: Boolean,
      default: false
    },
    expandableText: {
      required: false,
      type: String,
      default: ""
    },
    popup: {
      type: Object,
      default: () => {
        return {}
      }
    },
    checked: {
      required: false,
      type: Boolean,
      default: false
    },
    fieldId: {
      type: String,
      required: true
    },
    validation: {
      type: [String, Object],
      required: false,
      default: ""
    },
    validationName: {
      required: false,
      type: String,
      default: ""
    },
    validationMessage: {
      required: false,
      type: String,
      default: ""
    },
    checkOnClick: {
      required: false,
      type: Boolean,
      default: false
    },
    styles: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  mounted () {
    this.$emit("component-updated", {
      checked: !!this.checked
    });
    this.$emit("input", !!this.checked);
    if (document.querySelector('.modalOpener')) {
      document.querySelector('.modalOpener').addEventListener('click', function () {
        store.commit('setModalOptions', {
          type: 'custom',
          message: this.dataset.text,
          isActive: true,
          closeButton: true
        })
      })
    }
  },
  methods: {
    openPopup () {
      store.commit('setModalOptions', {
        type: 'custom',
        message: this.popup.description,
        isActive: true,
        closeButton: true
      })
    }
  },
  watch: {
    localChecked (value) {
      // this.$eventHub.$emit('checkbox-event', { id: this.fieldId, checked: value ? '1' : '0' });
      this.$emit("component-updated", {
        checked: value
      });
      this.$emit("input", value);
    }
  }
};
</script>

<style lang="scss" scoped>
$medium: 800px;

.popup {
  margin-left: 5px;
  cursor: pointer;
  font-weight: bold;
}

/* The container */
.container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 15px;
  line-height: 27px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 5px;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: transparent;
  border: 1px solid #797979;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: green;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 6px;
  top: 2px;
  width: 6px;
  height: 11px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.down-arrow {
  width: 16px;
  transition: all 0.3s;
  margin-left: 10px;
  margin-top: -8px;
}
.down-arrow[aria-expanded="true"] {
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}
</style>
